<template>
  <div class="forward_container">
    <div class="title">代发指南</div>
    <div class="content">
      <div class="line"></div>

      <div class="content_item">
        <div class="item_left">
          <img src="@/assets/icon／选择来源.png" alt="" class="image" />
        </div>
        <div class="item_right">
          <div class="top">
            <div class="num">1</div>
            <div class="text">选择来源</div>
          </div>
          <div class="bottom">
            选择数据来源平台 ，支持天猫、淘宝、阿里巴巴、拼多多、京东等各大平台
          </div>
        </div>
      </div>
      <div class="content_item">
        <div class="item_left">
          <img src="@/assets/icon／录入信息.png" alt="" class="image" />
        </div>
        <div class="item_right">
          <div class="top">
            <div class="num">2</div>
            <div class="text">录入信息</div>
          </div>
          <div class="bottom">录入收件人信息，支持模板导入、人工填写</div>
        </div>
      </div>
      <div class="content_item">
        <div class="item_left">
          <img src="@/assets/icon／选择礼品 (1).png" alt="" class="image" />
        </div>
        <div class="item_right">
          <div class="top">
            <div class="num">3</div>
            <div class="text">选择礼品</div>
          </div>
          <div class="bottom">根据需要选择礼品，满足补单、AB单各种需求</div>
        </div>
      </div>
      <div class="content_item">
        <div class="item_left">
          <img src="@/assets/icon／查看物流.png" alt="" class="image" />
        </div>
        <div class="item_right">
          <div class="top">
            <div class="num">4</div>
            <div class="text">查看物流</div>
          </div>
          <div class="bottom">确认信息无误后，提交订单，可随时查看快递单号</div>
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button
        round
        type="info"
        size="normal"
        color="#F93244"
        style="width: 91.467vw; margin-bottom: 5.333vw"
        @click="
          () => {
            $router.push('/buy');
          }
        "
        >立即选购礼品</van-button
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.forward_container {
  background-image: url(~@/assets/bg／代发指南.png);
  background-size: cover;
  height: 140.267vw;
  .title {
    font-size: 5.333vw;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    text-align: center;
    margin-bottom: 6.933vw;
    padding-top: 10.4vw;
  }
  .content {
    padding-left: 10.133vw;
    position: relative;
    .line {
      width: 1.067vw;
      height: 75.733vw;
      background: #ffeaec;
      position: absolute;
      top: 0;
      left: 13.867vw;
      z-index: -1;
    }
    &_item {
      height: 22.933vw;
      display: flex;
      margin-right: 12vw;
      z-index: 9999;
      .item_left {
        margin-right: 5.867vw;
        .image {
          width: 8.533vw;
          height: 8.533vw;
        }
      }
      .item_right {
        .top {
          display: flex;
          align-items: center;
          .num {
            margin-right: 1.067vw;
            transform: rotate(3deg);
            font-size: 6.133vw;
            font-family: Roboto;
            font-weight: 600;
            color: #f93244;
            line-height: 7.467vw;
          }
          .text {
            font-size: 3.733vw;
            font-weight: 600;
            color: #f93244;
          }
        }
        .bottom {
          color: rgba(0, 0, 0, 0.85);
          font-size: 2.933vw;
          line-height: 1.5;
        }
      }
    }
  }
  .btn {
    margin-top: 14.4vw;
    text-align: center;
  }
}
</style>
